import { Reducer } from 'redux'
import { FilterMobilePageState, FilterMobilePageActionTypes } from './types'

const initialState: FilterMobilePageState = {
	isVisible: false
}

const reducer: Reducer<FilterMobilePageState> = (state = initialState, action) => {
	switch (action.type) {
		case FilterMobilePageActionTypes.SHOW_FilterMobilePage: {
			return { ...state, isVisible: true }
		}
		case FilterMobilePageActionTypes.HIDE_SHOW_FilterMobilePage: {
			return { ...state, isVisible: false }
		}
		default: {
			return state
		}
	}
}

export { reducer as filterMobilePageReducer }
